<template>
  <v-container fluid tag="section" class="text_google login-page">
    <v-row justify="center" class="mt-6 mb-2">
      <v-col cols="12" md="8" class="text-center">
        <v-avatar size="72" class="mb-3">
          <v-img src="/ovec.png" alt="OVEC" contain></v-img>
        </v-avatar>
        <h1 class="brand-title">ระบบบริหารงานบุคคล สอศ.</h1>
        <p class="brand-subtitle mb-0">
          เลือกประเภทผู้ใช้งานด้านล่างเพื่อเข้าสู่ระบบ
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="6"><Loginuser /></v-col>
          <v-col cols="12" md="6"><LoginCollege /></v-col>
          <v-col cols="12" md="6"><Loginuser_gov /></v-col>
          <v-col cols="12" md="6"><LoginuserEtc /></v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2 mb-8">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="manual-banner"
          icon="mdi-shield-check-outline"
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <strong>ระบบมีการอัปเดตความปลอดภัย</strong> — บางบัญชีอาจได้รับแจ้งให้ตั้งรหัสผ่านใหม่ทันทีหลังเข้าสู่ระบบ
              ถือเป็นขั้นตอนปกติเพื่อความปลอดภัยของท่าน
              <a href="#" class="info-link" @click.prevent="showPasswordInfo = true">
                อ่านรายละเอียดกระบวนการจัดการรหัสผ่าน
              </a>
            </div>
            <v-btn color="primary" to="/news" rounded outlined class="ml-auto mt-2 mt-sm-0">
              <v-icon left small>mdi-book-open-page-variant</v-icon>คู่มือการใช้งาน
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <!-- อธิบายกระบวนการจัดการรหัสผ่านแบบละเอียด — เปิดจากลิงก์ในป้ายประกาศด้านบน
         ตั้งใจไม่ระบุรูปแบบ/ตัวอย่างรหัสผ่านเริ่มต้นไว้ตรงนี้ เพื่อไม่เปิดเผยข้อมูลที่ผู้ไม่ประสงค์ดี
         อาจนำไปใช้เดารหัสผ่านได้ -->
    <v-dialog v-model="showPasswordInfo" max-width="600">
      <v-card rounded="xl" class="password-info-card">
        <v-card-title class="password-info-header white--text">
          <v-icon left color="white">mdi-lock-check-outline</v-icon>
          กระบวนการจัดการรหัสผ่าน
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">1</v-avatar>
            <div>
              <strong>เข้าใช้งานครั้งแรก หรือจำรหัสผ่านไม่ได้</strong>
              <p class="mb-0 grey--text text--darken-1">
                กรุณาติดต่อผู้ดูแลระบบของหน่วยงานท่าน หรือกดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบของแต่ละประเภทผู้ใช้งานด้านบน
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">2</v-avatar>
            <div>
              <strong>ระบบขอให้ตั้งรหัสผ่านใหม่ทันทีที่เข้าสู่ระบบ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เป็นส่วนหนึ่งของการยกระดับความปลอดภัยของระบบ ไม่ใช่ความผิดพลาดของท่าน กรุณาตั้งรหัสผ่านใหม่ตามที่ระบบแนะนำก่อนใช้งานต่อ
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">3</v-avatar>
            <div>
              <strong>ลืมรหัสผ่าน</strong>
              <p class="mb-0 grey--text text--darken-1">
                กดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบ ระบบจะส่งรหัสยืนยัน (OTP) ไปยังอีเมลที่ลงทะเบียนไว้ในระบบเท่านั้น
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">4</v-avatar>
            <div>
              <strong>การตั้งรหัสผ่านที่ปลอดภัย</strong>
              <p class="mb-0 grey--text text--darken-1">
                อย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลขอย่างน้อยอย่างละ 1 ตัว และไม่ควรใช้ซ้ำกับรหัสผ่านที่ใช้ในระบบอื่น
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded @click="showPasswordInfo = false">เข้าใจแล้ว</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LoginCollege from "../components/core/loginCollege.vue";
import Loginuser from "../components/core/loginuser.vue";
import Loginuser_gov from "../components/core/loginuser_gov.vue";
import LoginuserEtc from "../components/core/loginuserEtc.vue";

export default {
  components: {
    Loginuser,
    LoginCollege,
    LoginuserEtc,
    Loginuser_gov
  },
  data() {
    return {
      showPasswordInfo: false
    };
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
</style>

<style scoped>
.text_google {
  font-family: "Kanit", sans-serif;
}

.login-page {
  min-height: 100vh;
}

.brand-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 4px;
}

.brand-subtitle {
  color: #718096;
  font-size: 1.05rem;
}

.manual-banner {
  border-radius: 12px;
}

.info-link {
  margin-left: 4px;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
}

.password-info-header {
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
}

.info-step p {
  font-size: 0.92rem;
  line-height: 1.5;
}

@media (max-width: 600px) {
  .brand-title {
    font-size: 1.5rem;
  }
}
</style>
